// Reopen Shopify consent controls without adding a fourth policy document.
document.addEventListener('click',async event=>{
 const trigger=event.target.closest('[data-cookie-preferences]');
 if(!trigger||typeof window.privacyBanner?.showPreferences!=='function')return;
 event.preventDefault();
 try{await window.privacyBanner.showPreferences()}catch{location.assign(trigger.href)}
});
